/* ────────────────────────────────────────────────────────────────────
 * About Prinotes (Arabic / العربية) — Modern Standard Arabic.
 *
 * Arabic mirror of about-en.ts. Same rules as the legal Arabic files:
 * MSA, no harakat unless needed, no em/en dashes, برَينوتس / برييورا
 * transliterated, Latin trademarks and emails left Latin.
 * ──────────────────────────────────────────────────────────────────── */

import type { AboutDoc } from './about-en';

export const ABOUT_AR: AboutDoc = {
  eyebrow: 'الشركة',
  title: 'عن برَينوتس',
  intro: [
    'برَينوتس مساحة عمل ذكية تفرّغ محادثاتك واجتماعاتك إلى نصوص وملاحظات منظمة ومخصصة لك، وتتيح لك تسجيلا صوتيا للمحادثات والاجتماعات وإدارة مواعيدك ومهامك بكل خصوصية وأمان.',
    'برَينوتس من تطوير شركة برييورا، شركة سعودية مقرها جدة. ونبني برَينوتس بما يتوافق مع نظام حماية البيانات الشخصية في المملكة العربية السعودية.',
  ],
  detailsHeading: 'بيانات الشركة',
  details: [
    { label: 'الكيان النظامي', value: 'شركة برييورا، شركة ذات مسؤولية محدودة بشخص واحد' },
    { label: 'الرقم الوطني الموحد', value: '7053899808' },
    { label: 'الموقع', value: 'جدة، المملكة العربية السعودية' },
  ],
  contactHeading: 'التواصل',
  contactIntro: 'للاستفسارات العامة، تواصل معنا. ولأي طلب محدد، استخدم عنوان التواصل المخصص له:',
  contacts: [
    { label: 'الاستفسارات العامة', email: 'info@prinotes.com' },
    { label: 'الدعم', email: 'support@prinotes.com' },
    { label: 'الخصوصية', email: 'privacy@prinotes.com' },
  ],
  privacyBefore: 'لمعرفة كيف نجمع بياناتك ونستخدمها ونحميها، اطلع على ',
  privacyLinkLabel: 'سياسة الخصوصية',
  privacyAfter: '.',
};
